import React from 'react';
import PropTypes from 'prop-types';
import AvatarOptions from '../AvatarOptions';
import { PARTS } from '../Avatar/consts';

const Eyewear = ({ config, updateConfig }) => {
  const getAvatarOptions = () =>
    [...Array(PARTS.EYEWEAR().length)].map((option, index) => {
      const conf = { ...config, eyewear: index };

      return {
        onClick: () => updateConfig(conf),
        config: conf
      };
    });

  return (
    <AvatarOptions
      name="eyewearType"
      config={config}
      options={getAvatarOptions()}
      withTop
    />
  );
};

Eyewear.propTypes = {
  config: PropTypes.object,
  updateConfig: PropTypes.func
};

export default Eyewear;
